(() => {
  const notification = document.querySelector('[data-halloween-notification]');
  if (!notification) return;
  let timer;
  const dismiss = () => {
    clearTimeout(timer);
    notification.hidden = true;
    document.removeEventListener('keydown', onKeydown);
  };
  const onKeydown = (event) => {
    if (event.key === 'Escape') dismiss();
  };
  notification.querySelector('[data-halloween-close]').addEventListener('click', dismiss);
  document.addEventListener('keydown', onKeydown);
  const show = () => {
    notification.hidden = false;
    requestAnimationFrame(() => {
      timer = setTimeout(dismiss, 4000);
    });
  };
  if (document.readyState === 'complete') show();
  else window.addEventListener('load', show, { once: true });
})();
